import { IExtraData } from "@rentiohq/shared-frontend/dist/forms/addContact/schema.addContact.types";
import {
  IFormikValues,
  IFormStep,
} from "@rentiohq/web-shared-next/dist/utils/types/form";
import { getInitialValues } from "./addCompany.utils";
import { uiSchema } from "./schema.addCompany";

export const addCompanySchema =
  (extraData: IExtraData) =>
  (): { formStepsSchema: IFormStep[]; initialValues: IFormikValues } => {
    const initialValues = getInitialValues(extraData);
    const formStepsSchema = [
      {
        uiSchema: uiSchema(extraData),
      },
    ];

    return { formStepsSchema, initialValues };
  };
